import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import ButtonLink from "@app/component/ButtonLink";
import { exitArchiveMode } from "@app/scene/settings/component/ManageFields/store/actions";
import { isArchiveMode } from "@app/scene/settings/component/ManageFields/store/selectors";
import { RootState } from "@app/store/rootReducer";

import styles from "./ArchiveAlert.module.scss";

interface Props {
  exitArchiveMode: typeof exitArchiveMode;
  isArchiveMode: boolean;
}

const ArchiveAlert: React.FC<Props> = ({ exitArchiveMode, isArchiveMode }) => {
  const intl = useIntl();

  const handleExitArchive = useCallback(() => {
    exitArchiveMode();
  }, [exitArchiveMode]);

  return isArchiveMode ? (
    <tr className={styles.container}>
      <td colSpan={6}>
        <span>
          {intl.formatMessage({
            id: "settings.manageFields.grid.archiveAlert.description",
            defaultMessage: "Showing archived fields only.",
            description: "Description of the archive alert on top of fields table",
          })}
        </span>

        <ButtonLink className={styles.btn} onClick={handleExitArchive}>
          {intl.formatMessage({
            id: "settings.manageFields.grid.archiveAlert.button",
            defaultMessage: "Return to active fields?",
            description: "Title of return button on top of fields table",
          })}
        </ButtonLink>
      </td>
    </tr>
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  isArchiveMode: isArchiveMode(state),
});

const mapDispatchToProps = {
  exitArchiveMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveAlert);
